export default __webpack_public_path__ + "static/media/background-about-mobile.34823453.png";